export default {
  'user.login': 'ورود',
  'user.signup': 'ثبت نام',
  'user.profile': 'پروفایل',
  'user.reset_password': 'بازنشانی رمز عبور ',
  'user.user_management': 'مدیریت کارمندان',
  'user.send_verification_sms': 'ارسال پیام تایید',
  'user.verification_check': 'بررسی کد تایید',
  'user.change_password': 'تغییر رمز عبور',
  'user.username_email': 'نام کاربری / ایمیل',
  'user.email': 'ایمیل',
  'user.changepass': 'رمز عبور شما با موفقیت تغییر کرد!',
  'user.phone': 'شماره موبایل بدون صفر',
  'user.password': 'رمز عبور',
  'user.forgetpassword': 'رمز عبور خود را فراموش کرده اید؟',
  'user.loginwithgoogle': 'ورود با حساب گوگل',
  'user.createaccount': 'ساخت حساب کاربری',
  'user.offerservices': 'تمام خدمات سفر را از ما بخواهید',
  'user.welcome': 'به تریپسی خوش آمدید',
  'user.justwelcome': 'ورود',
  'user.rememberme': 'مرا به خاطر بسپار',
  'user.donthaveaccount': 'قبلا ثبت نام نکرده اید؟',
  'user.clickhere': 'اینجا کلیک کنید',
  'user.firstname': 'نام',
  'user.englishfirstname': ' نام انگلیسی',

  'user.lastname': 'نام خانوادگی',
  'user.agreemessage': 'موافقم',
  'user.rotapolicy': 'قوانین تریپسی را می پذیرم',
  'user.rotapolicy_tripord': 'قوانین تریپ اُرد را می پذیرم',
  'user.rotacopyright': 'قوانین حق تکثیر تریپسی © 2018',
  'user.emptypass': 'لطفا رمز عبور جدید و قدیم را وارد نمایید',
  'user.oldpass': 'رمز عبور قدیمی اشتباه است',
  'user.employeeadd': 'کارمند مورد نظر با موفقیت ثبت گردید',
  'user.tryagain': 'لطفا مجددا تلاش نمایید',
  'user.newpass': 'لطفا رمز عبور جدید را وارد نمایید',
  'user.changepasssuccess': 'رمز عبور تغییر نکرد',
  'user.changepasserror': 'رمز های عبور وارد شده همخوانی ندارند',
  'user.loginerror': 'نام کاربری یا رمز عبور اشتباه می باشد',
  'user.userlock': 'نام کاربری شما قفل است',
  'user.tripsi': 'تریپسی',
  'user.tripord': 'تریپ ارد',
  'user.userpoint': 'امتیازدهی',
  'user.duplicatedusername': 'ایمیل وارد شده تکراری است',
  'user.signuperror': 'ایمیل یا نام کاربری وارد شده تکراری است',
  'user.avatar': 'آواتار',
  'user.forgetyour': 'فراموشی',
  'user.createyour': 'حساب کاربری خود',
  'user.account': 'را بسازید',
  'user.registerwith': 'ثبت نام با حساب کاربری',
  'user.acceptrules': 'لطفا جهت ثبت نام ابتدا قوانین سایت را تایید نمایید',
  'user.fillallfield': 'لطفا تمامی فیلدها را وارد نمایید',
  'user.favourites': 'علاقه مندی ها',
  'user.nograde': 'بدون رتبه',
  'user.phone': 'شماره موبایل',
  'user.has_account': 'قبلا عضو تریپسی بوده ام',
  'user.has_account_tripord': 'قبلا عضو تریپ اُرد بوده ام',
  'user.signup_free': 'ثبت نام رایگان',
  'user.pass_recovery': 'بازیابی رمز عبور',
  'user.remember_password': 'رمزتان را بخاطر دارید؟',
  'authentication.slugone': 'معتبرترین عرضه‌کننده خدمات گردشگری در ایران',
  'user.otplogin': 'با ارسال کد از طریق پیامک وارد شوید',
  'user.otplogintitle': 'رمز یکبار مصرف',
  'user.incorrectcode': 'کد وارد شده صحیح نمی باشد',
  'user.untilresend': 'تا ارسال مجدد',
  'user.phoneoremail': 'ایمیل یا موبایل',
  'user.loginwithusername': 'با نام کاربری وارد شوید',
  'user.sendcode': 'ارسال کد',
  'user.sendagain': ' ارسال مجدد',
};
